import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .node-widget-container {
    margin: 0;
  }
`;

interface ContainerProps {
  $isPoweredOn: boolean;
  $isInMaintenance: boolean;
  theme: { token: CustomThemeToken };
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  background-color: ${({ $isPoweredOn, $isInMaintenance, theme: { token } }) =>
    !$isPoweredOn
      ? token.Ecoplant_Compressor.colorBGStopped
      : $isInMaintenance
      ? token.Ecoplant_Compressor.colorBGMaintenance
      : token.colorBgContainer};
  border: ${({ $isPoweredOn, $isInMaintenance, theme: { token } }) =>
    !$isPoweredOn
      ? `2px solid ${token.Ecoplant_Compressor.colorBGStopped}`
      : $isInMaintenance
      ? `2px dashed ${token.colorWarningBorder}`
      : 'none'};
  overflow: hidden;

  .package-care-wrapper {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
  }
`;
